import * as helpers from './helpers'

const reduce_list = helpers.createListReducer({listViewName: 'paris_validacijas_rezultati_list', actionsName: 'paris_validacija_rezultati'})

export const paris = (state = helpers.listEditGetInitialState(), {type, payload, reqId}) => {
    return reduce_list({ state, type, payload, reqId })
}

